module.exports = __webpack_public_path__ + "img/a-bg3.c29b3b64.png";